const keys: <T extends object>(obj: T) => Extract<keyof T, string>[] =
  Object.keys;

export default keys;
